import React, { useEffect, useState } from "react";
import {
  Button,
  FormControlLabel,
  MenuItem,
  Stack,
  Switch,
  TextField,
} from "@mui/material";
import { getFieldSettings } from "../../../../../../../utils/fieldSettings";

const InstanceFieldSettings = ({ field, overrides, disabled, onChange }) => {
  const type = field?.field_type ?? field?.type;
  const isGroup = ["checkboxGroup", "selectGroup"].includes(type);
  const allowMultiple = type === "selectGroup" && Boolean(field?.multiple);
  const settings = getFieldSettings({ field_settings: overrides });
  const defaults = Array.isArray(field?.def_value) ? field.def_value : [];
  const defaultsKey = JSON.stringify(defaults);
  const [showDefaults, setShowDefaults] = useState(defaults.length > 0);
  useEffect(() => {
    setShowDefaults(JSON.parse(defaultsKey).length > 0);
  }, [defaultsKey]);

  const options = Array.from(
    new Map(
      (field?.options || []).map((option) => {
        const id = option?.field_id ?? option?.value;
        return [
          id,
          { value: id, label: option?.label ?? option?.field_label ?? id },
        ];
      }),
    ).values(),
  ).filter((option) => option.value);

  const toggle = (key, label) => (
    <FormControlLabel
      label={label}
      control={
        <Switch
          checked={Boolean(field?.[key])}
          disabled={disabled}
          onChange={(event) => {
            const value = event.target.checked;
            onChange({
              [key]: value,
              ...(key === "multiple" && !value && defaults.length > 1
                ? { def_value: defaults.slice(0, 1) }
                : {}),
            });
          }}
        />
      }
    />
  );

  return (
    <Stack spacing={0.5}>
      {toggle("required", "Required")}
      {isGroup && (
        <>
          {type === "selectGroup" && toggle("multiple", "Allow Multiple")}
          {toggle("mark_circle", "Mark As Circle")}
          <FormControlLabel
            label="Use a default value"
            control={
              <Switch
                checked={showDefaults || defaults.length > 0}
                disabled={disabled}
                onChange={(event) => {
                  const enabled = event.target.checked;
                  setShowDefaults(enabled);
                  if (!enabled) onChange({ def_value: [] });
                }}
              />
            }
          />
          {(showDefaults || defaults.length > 0) && (
            <TextField
              select
              size="small"
              label="Default Value"
              disabled={disabled || !options.length}
              value={allowMultiple ? defaults : (defaults[0] ?? "")}
              SelectProps={{ multiple: allowMultiple }}
              onChange={(event) => {
                const value = event.target.value;
                onChange({
                  def_value: Array.isArray(value)
                    ? value
                    : value
                      ? [value]
                      : [],
                });
              }}
            >
              {options.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          )}
        </>
      )}
      {Object.keys(settings).length > 0 && (
        <Button
          size="small"
          disabled={disabled}
          onClick={() => {
            setShowDefaults(false);
            onChange(
              isGroup
                ? {
                    required: null,
                    multiple: null,
                    mark_circle: null,
                    def_value: null,
                  }
                : { required: null },
            );
          }}
        >
          Reset to field settings
        </Button>
      )}
    </Stack>
  );
};

export default InstanceFieldSettings;
